import { Axios } from "../utils/axios.js";

export const deleteAll = () => {
  return Axios.post("/trainAdmin/enterAdmin/recycleRemoveAll");
};
export const recoverAll = () => {
  return Axios.post("/trainAdmin/enterAdmin/removeRecoverAll");
};



// WEBPACK FOOTER //
// ./src/api/question.js